import { Flex, IconButton, Tooltip } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../app-state/store';
import { useCurrentColors } from '../../hooks/UseCurrentColors/UseCurrentColors';
import { useCheckForMobileOrTablet } from '../../hooks/UseResponsive/UseResponsive';
import ActAddcl from '../Icons/ActAddcl';
import NavClient from '../Icons/NavClient';
import Tags from '../Tags/Tags';
import { getNavBarMaxUsers } from './Navbar';
interface UsersProps extends Clients {
    onSelectUser: (user: PortfolioUser) => void;
    onDeleteUser: (user: PortfolioUser) => void;
    onAddUser: (args: any) => void;
    selectedMenu: any;
    t: any;
}
export default function Users({
    users,
    groups,
    selectedUser,
    onSelectUser,
    onDeleteUser,
    selectedMenu,
    t,
}: UsersProps) {
    const router = useNavigate();
    const currentColors = useCurrentColors();
    const navBarMaxUsers = getNavBarMaxUsers(useCheckForMobileOrTablet());
    const mGroups: PortfolioUser[] = [];
    const isMobile = useCheckForMobileOrTablet();
    const { user, switchUser } = useSelector((state: RootState) => state.auth);
    const {
        menuStructure: {
            data: { pagesWithSubmenu },
        },
    } = useSelector((state: RootState) => state.appData);

    groups?.forEach((group) => {
        if (group?.users?.length > 0) {
            mGroups.push({
                uniqueId: group.uniqueId,
                id: group.users?.map((u) => u.id).join(','),
                username: group.name,
                displayName: group.name,
                meta: group.users?.map((u) => u.displayName).join(','),
                users: group.users,
                type: 'GROUPED_CLIENT',
            });
        }
    });

    const items = users?.concat(mGroups) || [];
    if (
        pagesWithSubmenu.includes(selectedMenu) &&
        selectedMenu !== 'review-all'
    ) {
        return (
            <Flex alignItems="center">
                <Tags
                    mx="10px"
                    items={
                        isMobile && selectedUser
                            ? [selectedUser]
                            : items.slice(0, navBarMaxUsers)
                    }
                    selected={selectedUser}
                    uniqueId={'uniqueId'}
                    dataKey="displayName"
                    tooltipKey="meta"
                    onClick={onSelectUser}
                    onDelete={onDeleteUser}
                />
                {items?.length <= navBarMaxUsers &&
                    user?.role !== 'Customer' &&
                    switchUser?.role !== 'Customer' && (
                        <Tooltip
                            aria-label="add-user"
                            label={
                                isMobile
                                    ? t('ui.mm.tooltip.select-client')
                                    : t('ui.mm.tooltip.add-client')
                            }
                            placement="bottom-start"
                            hasArrow>
                            <IconButton
                                background="transparent"
                                cursor="pointer"
                                border="none"
                                icon={isMobile ? <NavClient /> : <ActAddcl />}
                                variant="ghost"
                                aria-label="add-user"
                                height="26px !important"
                                width="26px !important"
                                color={currentColors.contentText}
                                onClick={() => {
                                    router({
                                        pathname: `/${selectedMenu}`,
                                    });
                                }}
                                _hover={{ backgroundColor: 'transparent' }}
                                _focus={{
                                    border: '0px',
                                    backgroundColor: 'transparent',
                                    outline: 'none',
                                }}
                                _active={{ border: '0px' }}
                            />
                        </Tooltip>
                    )}
            </Flex>
        );
    }
    return null;
}
